import React from 'react';
import Immutable from 'immutable';
import Slider from 'react-slick';

import {
  CoreLink,
  ImageFromField,
} from '@uncinc/react-drupal-core';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  CONTENT_IMAGE_PLACEHOLDER,
} from '../../config/constants';


const HeroSlider = ({ entity, sliderRef }) => {

  return (
    <Slider
      className="Slider"
      ref={sliderRef}
      draggable
      arrows={false}
      autoplay
      autoplaySpeed={7000}
      fade
      swipe
      lazyLoad
      infinite
      slidesToShow={1}
    >
      {entity.get('field_carousel_paragraph_items', Immutable.List()).map((paragraph, index) => {
        const paragraphEntity = paragraph.get('entity');
        const referencedContentTitle = paragraphEntity.getIn(['field_content_item', 0, 'entity', 'title', 0, 'value'], '');
        const referencedContentImage = paragraphEntity.getIn(['field_content_item', 0, 'entity', 'field_image', 0], null);
        const referencedContentUrl = paragraphEntity.getIn(['field_content_item', 0, 'url'], '');
        const referencedContentNid = paragraphEntity.getIn(['id', 0, 'value'], '');

        return (
          <div key={`image_slide:${referencedContentNid}`} className="Slider__slide">
            <CoreLink to={referencedContentUrl}>
              {referencedContentImage ? (
                <ImageFromField
                  includeWebP
                  lazyload={false}
                  className="Hero__image"
                  field={referencedContentImage}
                  imageStyles={Immutable.Map({
                    [SCREEN_MOBILE]: 'crop_1_1',
                    [SCREEN_TABLET]: 'crop_3_2',
                  })}
                />
              ) : <img src={CONTENT_IMAGE_PLACEHOLDER} alt="Content placeholder" />}
              <div className="Slider__slide--overlay" />

              <div className="Slider__slide__action">

                <h3>
                  {referencedContentTitle}
                </h3>
                <i className="icon icon-arrow-right-filled icon-variant-4" />

              </div>
            </CoreLink>
          </div>
        );
      })}

    </Slider>
  );
};

export default HeroSlider;
